import { HashLink as Link } from 'react-router-hash-link';
import React from 'react'
import anim from '../../assets/images/anim_line.png'
import blueapp from '../../assets/images/appstore_blue.png'
import whiteapp from '../../assets/images/appstore_white.png'
import blue from '../../assets/images/googleplay_blue.png'
import white from '../../assets/images/googleplay_white.png'
import nexaLogo from '../../assets/images/nexa-logo.png'
import screen2 from '../../assets/images/app-screens/nexa-screenshot-2.png'
import screen3 from '../../assets/images/app-screens/nexa-screenshot-3.png'

function Sliderone() {

    return (
        <>
            <section className="banner_section home-banner">
                <div className="container">
                    <div className="anim_line">
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                        <span><img src={anim} alt="anim_line" /></span>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-12" data-aos="fade-right" data-aos-duration="1500">
                            <div className="banner_text">
                                <h1 className="hero_logo_heading">
                                    <img src={nexaLogo} alt="Nexa" />
                                </h1>
                                <p>Experience the future of insurance protection today smarter, simpler, and designed to give you greater peace of mind.</p>
                            </div>
                            <ul className="app_btn">
                                <li>
                                    <Link to="#">
                                        <img className="blue_img" src={blueapp} alt="image" />
                                        <img className="white_img" src={whiteapp} alt="image" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <img className="blue_img" src={blue} alt="image" />
                                        <img className="white_img" src={white} alt="image" />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-md-12" data-aos="fade-in" data-aos-duration="1500">
                            <div className="banner_slider nexa-phone-stage" aria-label="Nexa mobile application previews">
                                <div className="nexa-phone-glow" aria-hidden="true"></div>
                                <div className="nexa-device nexa-device-home">
                                    <span className="nexa-dynamic-island" aria-hidden="true"></span>
                                    <div className="nexa-device-screen">
                                        <img src={screen2} alt="Nexa home dashboard" />
                                    </div>
                                </div>
                                <div className="nexa-device nexa-device-products">
                                    <span className="nexa-dynamic-island" aria-hidden="true"></span>
                                    <div className="nexa-device-screen">
                                        <img src={screen3} alt="Nexa products screen" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Sliderone
